var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 83,
    viewBox: "0 0 74 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.314 76.2207C42.314 76.2207 42.314 70.0761 42.314 66.6624C42.314 63.2487 42.883 58.5833 42.883 56.1938C42.883 53.8042 43.3381 49.9353 42.314 47.6595C42.314 47.6595 40 42.7666 40 32.5255C40 22.2845 41.6686 21.9813 41.8206 18.7952C41.8206 18.7952 41.7451 14.3192 42.4278 11.7594C43.1106 9.19956 43.3381 8.06167 45.1588 6.24103C46.9794 4.4204 48.0035 3.96524 48.6862 4.24926C49.369 4.53328 50.6207 5.38716 49.1978 8.06167C47.7759 10.7353 46.8083 10.5077 45.6139 10.3939",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.696 81.0001C61.696 81.0001 59.4958 69.6967 59.9455 62.7938C60.3943 55.8909 59.5723 53.8427 59.9455 50.6566C60.3187 47.4704 62.1512 46.4081 63.0069 45.1191C63.8626 43.8301 66.2476 41.6299 69.2061 39.5816C72.1647 37.5334 72.2402 36.4711 72.2402 34.8025C72.2402 33.1339 72.4678 31.3888 72.923 28.6578C73.3781 25.9269 73.5302 24.7134 72.923 23.8787C72.3158 23.0439 70.5716 22.5132 69.7369 18.9766C68.9021 15.44 67.3855 16.7491 67.3855 16.7491C67.3855 16.7491 63.9336 19.1569 66.9304 26.2309C66.9304 26.2309 67.4046 27.4444 68.4852 27.4071C69.3545 27.3761 70.5334 27.123 70.5334 27.123",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0357 10.375L46.921 11.5784L46.7744 13.1214L46.7034 13.8642C46.7034 13.8642 46.6369 14.7746 46.4094 16.9939C46.4094 16.9939 46.1818 18.5296 46.7225 18.5296",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0845 4.17124C49.0845 4.17124 50.1659 2.77026 51.759 2.77026C53.352 2.77026 56.2532 3.28186 55.9118 5.55765C55.5705 7.83345 51.7499 7.83345 50.7349 7.32185",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0342 2.77006C54.0342 2.77006 54.3755 1.12057 56.4238 1.00587C58.472 0.891166 59.6099 2.48513 60.4064 3.4528C61.2029 4.42047 60.5202 6.63891 57.5617 6.63891C57.5617 6.63891 56.1962 6.56335 55.6272 6.31666",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7139 3.50937C60.7139 3.50937 61.9992 2.31503 63.7634 2.77019C65.5276 3.22535 65.8863 5.03779 64.2359 7.15064",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6006 7.89079C63.535 7.94723 64.235 7.15161 64.235 7.15161C64.235 7.15161 64.5018 8.74467 64.2742 10.6791C64.0466 12.6135 64.8732 14.964 65.0425 15.857C65.2118 16.7491 65.2118 16.7491 65.2118 16.7491C65.2118 16.7491 65.5359 18.8273 65.7107 20.749",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4083 7.59839C53.4083 7.59839 53.2945 10.7927 51.5312 11.2478",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4697 16.5113C52.4697 16.5113 52.9531 15.8559 52.9531 14.8891C52.9531 13.9224 52.711 10.2593 52.711 10.2593",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4723 16.1975C58.4723 16.1975 58.3012 13.4483 58.1874 11.9499C58.0736 10.4516 58.3012 7.83441 58.9275 6.63916",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4278 8.24561C58.4278 8.24561 58.0154 9.47544 55.939 9.42264",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3462 9.82617C64.3462 9.82617 64.2752 11.817 61.6016 11.4183",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7773 60.5273C36.556 63.5872 35.4232 65.9961 33.3789 67.7539C31.3477 69.5117 28.6654 70.3906 25.332 70.3906C21.6862 70.3906 18.8151 69.1667 16.7188 66.7188C14.6354 64.2578 13.5938 60.8854 13.5938 56.6016V54.8633C13.5938 52.1289 14.0755 49.7201 15.0391 47.6367C16.0026 45.5534 17.3763 43.9583 19.1602 42.8516C20.957 41.7318 23.0404 41.1719 25.4102 41.1719C28.6914 41.1719 31.3346 42.0508 33.3398 43.8086C35.3451 45.5664 36.5039 48.0339 36.8164 51.2109H30.957C30.8138 49.375 30.2995 48.0469 29.4141 47.2266C28.5417 46.3932 27.207 45.9766 25.4102 45.9766C23.457 45.9766 21.9922 46.6797 21.0156 48.0859C20.0521 49.4792 19.5573 51.6471 19.5312 54.5898V56.7383C19.5312 59.8112 19.9935 62.0573 20.918 63.4766C21.8555 64.8958 23.3268 65.6055 25.332 65.6055C27.1419 65.6055 28.4896 65.1953 29.375 64.375C30.2734 63.5417 30.7878 62.2591 30.918 60.5273H36.7773Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2424 58.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChand);
export default __webpack_public_path__ + "static/media/Chand.fdb882bf560b86606c51edca2f6b6a2d.svg";
export { ForwardRef as ReactComponent };